// extracted by mini-css-extract-plugin
export var anchor = "_4s-0";
export var discard = "_4s-4";
export var muiTooltipTooltip = "_4s-6";
export var notificationBar = "_4s-3";
export var saveButtonHoverSlotWrapper = "_4s-5";
export var show = "_4s-2";
export var spacer = "_4s-1";